import React from "react";
import { TaskResponse } from "./TaskResponse";

export function Task() {
  return (
    <div className="task h-full">
      <TaskResponse />
    </div>
  );
}